import { cn } from "@omni/utils/styles";

export type HamburgerProps = {
    active: boolean;
    handleClick: () => void;
};

const Hamburger = ({ active, handleClick }: HamburgerProps) => (
    <div
        onClick={() => handleClick()}
        className={cn(
            "tw:w-7 tw:hover:cursor-pointer",
            "tw:after:content-[''] tw:after:bg-white tw:after:rounded-[1px] tw:after:block tw:after:h-0.5 tw:after:my-1.75 tw:after:transition-all tw:after:duration-200 tw:after:ease-in-out",
            "tw:before:content-[''] tw:before:bg-white tw:before:rounded-[1px] tw:before:block tw:before:h-0.5 tw:before:my-1.75 tw:before:transition-all tw:before:duration-200 tw:before:ease-in-out",
            {
                "tw:before:translate-y-2.25 tw:before:rotate-135 tw:after:-translate-y-2.25 tw:after:-rotate-135":
                    active
            }
        )}
    >
        <div
            className={cn(
                "tw:content-[''] tw:bg-white tw:rounded-[1px] tw:block tw:h-0.5 tw:my-1.75 tw:transition-all tw:duration-200 tw:ease-in-out",
                { "tw:scale-0": active }
            )}
        />
    </div>
);

export default Hamburger;
